import type { ILoanContractNumberOptionMeta } from "@/modules/application/common/types";
import { CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage } from "@/shared/components";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { components } from "@ab.uitools/ui-library/components/ReactSelect";
import type { OptionProps, TOption } from "@ab.uitools/ui-library/components/ReactSelect/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

export const LoanContractNumberSelectOption = (props: OptionProps<TOption>) => {
  const { currency, type, index } = props.data.meta as ILoanContractNumberOptionMeta;
  return (
    <components.Option {...props}>
      <div className="select-option-item">
        <div>
          {!!index && (
            <Divider
              color="light"
              type="primary"
              className="full-width"
              isHorizontal
            />
          )}
          <div
            className="flexbox justify-content--between align-items--center py-8">
            <div>
              <div>
                <Text
                  weight="semibold"
                  size="medium"
                >
                  {props.data?.value}
                </Text>
                <Text type="tertiary" size="medium">
                  {type} • {currency}
                </Text>
              </div>
            </div>
            <div className="flexbox">
              {props.isSelected && (
                <CloudFlareImage
                  className="ml-4"
                  size="small"
                  path={CloudflareAsset.SelectedOption}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </components.Option>
  );
};
